var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarNoselection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50044 14.4055L9.75869 14.5617L14.0816 17.1763L14.0817 17.1764C14.493 17.4253 14.9965 17.0595 14.8879 16.5924L13.7421 11.676L13.6737 11.3822L13.9017 11.1846L17.7246 7.87211L17.7248 7.87196C18.0894 7.55629 17.8902 6.96301 17.4186 6.9255L17.416 6.92529L12.3847 6.4982L12.0843 6.4727L11.9666 6.19508L9.99789 1.54925L9.99722 1.54768C9.81459 1.11257 9.18526 1.11257 9.00262 1.54768L9.00181 1.54962L7.03305 6.18503L6.91529 6.4623L6.61513 6.48778L1.58388 6.91486L1.58124 6.91509L1.58124 6.91508C1.10966 6.95259 0.910442 7.54588 1.27509 7.86154L1.27527 7.86169L5.09818 11.1742L5.32618 11.3717L5.25771 11.6656L4.11193 16.582L9.50044 14.4055ZM9.50044 14.4055L9.24192 14.5613M9.50044 14.4055L9.24192 14.5613M9.24192 14.5613L4.919 17.1654L4.91811 17.166M9.24192 14.5613L4.91811 17.166M4.91811 17.166C4.50688 17.4149 4.00347 17.0492 4.11187 16.5822L4.91811 17.166ZM14.2291 11.5625L18.052 8.24999L14.2291 11.5625Z",
    fill: "white",
    stroke: "#858383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarNoselection);
export default __webpack_public_path__ + "static/media/star_noselection.abe37b0f990ea6f4010ffe4c5b6020ea.svg";
export { ForwardRef as ReactComponent };